app.ThirdPartyOrderList = app.AbstractCollection.extend({
  model: app.ThirdPartyOrder,

  comparator(model) {
    return model.get('createdAt') * -1;
  },

  url() {
    return '/api/v2/third-party-orders';
  },

  fetchModelWithId(modelId, callback) {
    this.fetch({
      url: `/api/v2/third-party-orders/${modelId}`,
      remove: false,
      showErrorModal: false,
      error(_collection, err) {
        callback(err);
      },
    });
  },
});
